export const positionLinkSingle = (
  positionId: string,
  isEditMode: boolean = false
): string => {
  let link = `/position/${positionId}`;
  if (isEditMode) {
    link += "?mode=edit";
  }
  return link;
};
